import { render, staticRenderFns } from "./SportsList.vue?vue&type=template&id=46943328"
import script from "./SportsList.vue?vue&type=script&lang=js"
export * from "./SportsList.vue?vue&type=script&lang=js"
import style0 from "./SportsList.vue?vue&type=style&index=0&id=46943328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports